import { Platform } from 'react-native';
import { supabase } from '../../shared/supabase/supabaseClient';
import { trackGA4Event } from '../../shared/analytics/ga4';

/**
 * Eventos del funnel alta → día 1 → primera venta (programa UX, epic #1362).
 * El whitelist vive en `public.track_onboarding_funnel_event`
 * (supabase/migrations/20262083000000_onboarding_funnel_events.sql).
 */
export type OnboardingFunnelEvent =
  | 'onboarding_wizard_view'
  | 'onboarding_step_completed'
  | 'onboarding_completed'
  | 'day1_phase_entered'
  | 'day1_cta_clicked'
  | 'catalog_product_created'
  | 'checkout_completed'
  | 'appointment_created';

/**
 * Envía evento del funnel:
 * - RPC track_onboarding_funnel_event → ops.onboarding_funnel_events (todas las
 *   plataformas; GA4 no llega a iOS/Android). Fire-and-forget: nunca bloquea
 *   ni rompe la UI.
 * - GA4 (gtag) solo en web, no-op si no está inicializado.
 */
export function trackOnboardingFunnel(
  name: OnboardingFunnelEvent,
  params?: Record<string, unknown>,
): void {
  trackGA4Event(name, { funnel: 'onboarding', ...params });
  void supabase
    .rpc('track_onboarding_funnel_event', {
      p_event_name: name,
      p_params: { platform: Platform.OS, ...params },
    })
    .then(({ error }) => {
      if (error && __DEV__) {
        console.warn('[onboarding-funnel] rpc', error.message);
      }
    });
  if (__DEV__) {
    console.info('[onboarding-funnel]', name, params ?? {});
  }
}
